<div class="context-menu find-similar-instruments-filter-window" (clickOutside)="closeContextMenu()" [clickOutsideEvents]="'click,contextmenu,mousedown'">
    <div class="context-menu-background"></div>

    <div class="find-similar-instruments-filter-container">
        <div class="title-row">
            <div class="title">Filters</div>
            <div class="reset-filter">
                <a-button [icon]="'/assets/img/menu/variations.svg'" iconWidth="10px" iconPos="right" (click)="resetFilter()" label="Reset filter"></a-button>
            </div>
        </div>

        <hr>

        <div class="filter-options">
            <div class="left" *ngIf="data?.filter">
                <div class="styles">
                    <div class="title">
                        {{ data?.filter?.categories?.name }}
                    </div>
                    <div class="style" *ngFor="let item of data.filter.categories.data | keyvalue">
                        <radio-button [class]="'gp-library-filters'" [type]="'checkbox'" [id]="item.key" [value]="item.key" [label]="item.key" (onSelect)="changeSelectedFilters($event, 'categories', item.key)" [selectedValue]="item.value ? item.key : null"></radio-button>
                    </div>
                </div>
            </div>
        </div>   

    </div>
</div>